import $ from 'jquery';
import Numbered from 'input.numbered';

export default class {
	constructor(options) {
		const defaults = {
			el: '#backwayCartPhoneTemp'
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	render() {
		if (this.$el.length) {
			console.log(this.$el);
			this.numbered = new Numbered(this.$el, {placeholder: false});
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/scripts/bakway/modem-order/modem-order.js